import { call, put, takeEvery } from 'redux-saga/effects'
import { api } from '../services/api'
import { logRavenError, setUserContext } from '../services/raven'
import { publishTracking } from '../services/tracking'
import {
  LOGIN_PENDING_DETAILS,
  GOOGLE_LOGIN_PENDING,
  GOOGLE_LOGIN_SUCCESS,
  GOOGLE_LOGIN_FAIL,
  CHANGE_AUTH_STATE,
} from '../actions/index'
import constants from '../constants/index'
import sendPostMessage from '../services/post-communication'

function* onGoogleLogin(action) {
  const { payload } = action
  let user

  try {
    if (payload.googleId) {
      user = yield call(api.googleLogin, { ...payload, providerToken: payload.accessToken })
    } else if (payload.client_id) {
      // second screen details
      user = yield call(api.googleLogin, {
        client_id: payload.client_id,
        provider: 'google_plus',
        providerToken: payload.providerToken,
        terms: payload.terms,
        newsletter: payload.newsletter,
      })
    }

    if (user.status === 202) {
      yield put({ type: LOGIN_PENDING_DETAILS, payload: user })
    } else if (user.status === 201) {
      yield put({ type: GOOGLE_LOGIN_SUCCESS, payload: user })
      yield put({ type: CHANGE_AUTH_STATE, payload: user.data })

      if (!payload.isRedirectFlow) {
        yield call(sendPostMessage, {
          ...user.data,
          ...constants.USER_ACTIONS.login,
          loginMethod: 'google',
        })

        publishTracking({
          clientId: JSON.parse(user.config.data).client_id,
          userAction: 'sign in',
          origin: 'googleplus',
          event: 'event44',
        })
      }

      yield call(setUserContext, { email: user.data.email })
    }
  } catch (e) {
    yield put({ type: GOOGLE_LOGIN_FAIL, payload: e.response })
    yield call(logRavenError, 'G+ login error', e, e.response)

    if (!payload.isRedirectFlow) {
      publishTracking({
        userAction: 'login error',
        origin: 'googleplus',
        event: 'event147',
      })
    }
  }
}

export default function* googleLogin() {
  yield takeEvery(GOOGLE_LOGIN_PENDING, onGoogleLogin)
}



// WEBPACK FOOTER //
// ./src/sagas/google.js